<template>
  <v-app app>
    <app-bar />

    <app-notification />

    <v-slide-x-transition hide-on-leave>
      <router-view />
    </v-slide-x-transition>

    <app-footer />

    <snack-bar />

    <app-error />

    <v-fab-transition>
      <v-btn
        v-show="consent"
        fab
        dark
        small
        color="primary"
        fixed
        right
        bottom
        @click="consent = false"
      >
        <v-icon dark>mdi-cookie-settings</v-icon>
      </v-btn>
    </v-fab-transition>
    <!-- <v-bottom-navigation
      app
      dark
      background-color="primary"
      scroll-target="50000px"
      :input-value="!consent"
    >
      <v-col class="text-center" cols="12">
        เว็บไซต์นี้มีการใช้คุ้กกี้.
        ในขณะที่ใช้งานเว็บไซต์คุณจะให้การยินยอมกับเราในการเก็บคุ้กกี้
        <a @click="openPolicy" class="white--text"
          ><u>นโยบายความเป็นส่วนตัว</u>
        </a>

        <v-btn class="ml-4 py-2 px-0" color="white" @click="onConsent()">
          <span class="text-body-2 black--text">ปิด</span>
        </v-btn>
      </v-col>
    </v-bottom-navigation> -->
    <v-expand-transition>
      <v-footer dark app padless v-show="!consent">
        <v-card class="flex" flat tile color="primary">
          <v-col class="text-center" cols="12">
            เว็บไซต์นี้มีการใช้คุ้กกี้.
            ในขณะที่ใช้งานเว็บไซต์คุณจะให้การยินยอมกับเราในการเก็บคุ้กกี้
            <a @click="openPolicy" class="white--text"
              ><u>นโยบายความเป็นส่วนตัว</u>
            </a>

            <v-btn
              class="ml-4 py-2 px-0"
              depressed
              color="white"
              height="30"
              @click="onConsent()"
            >
              <span class="text-body-2 black--text">ปิด</span>
            </v-btn>
          </v-col>
        </v-card>
      </v-footer>
    </v-expand-transition>
  </v-app>
</template>
<script>
export default {
  data() {
    return {
      consent: true,
      value: 1,
    };
  },

  async mounted() {
    if (this.$cookie.get("consent") === null) {
      this.$cookie.set("consent", false);
      this.consent = false;
    } else {
      this.consent = this.$cookie.get("consent") === "true" ? true : false;
    }
  },

  methods: {
    openPolicy() {
      window.open("https://www.cmu.ac.th/th/privacy");
    },
    onConsent() {
      this.$cookie.set("consent", true);
      this.consent = true;
    },
  },
};
</script>
